// src/components/steps/Step4Publish.jsx
//
// Wizard step 4 — the confirmed output (state.confirmedOutput) with its export
// action; an empty state until one is confirmed.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS, FONT_MONO, RADII } from '../../constants/theme.js';

const Step4Publish = ({ state, onExport, renderEntry, color, w, t }) => {
  const { t: tr } = useTranslation('wizard');
  const { confirmedOutput } = state;
  const c = color;

  if (!confirmedOutput) {
    return (
      <div style={{ padding: '40px 20px', textAlign: 'center', background: t.surface, borderRadius: RADII.card, border: `1px solid ${t.border}` }}>
        <div style={{ fontSize: '15px', color: t.textMuted, marginBottom: '12px' }}>{tr('step4.empty')}</div>
      </div>
    );
  }

  const entryColor = confirmedOutput.modeConfig?.color || c;

  return (
    <div style={{ padding: '20px', background: t.surface, borderRadius: RADII.card, border: `1px solid ${t.border}` }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
        <span style={{ fontWeight: 700, fontSize: '15px' }}>{tr('step4.confirmedOutput')}</span>
        <span style={{ padding: '3px 10px', borderRadius: RADII.controlInner, background: `${entryColor}20`, color: entryColor, fontSize: '11px', fontWeight: 700 }}>{confirmedOutput.modeConfig?.name}</span>
        {confirmedOutput.generationDuration && <span style={{ fontSize: '11px', color: t.textFaint, fontFamily: FONT_MONO }}>{confirmedOutput.generationDuration}s</span>}
      </div>

      {/* Content preview */}
      <div style={{ marginBottom: '16px' }}>
        {renderEntry(confirmedOutput)}
      </div>

      {/* Action row */}
      <div style={{ display: 'flex', gap: '10px' }}>
        <button onClick={() => onExport(confirmedOutput)} style={{ padding: '14px 22px', borderRadius: RADII.control, background: w(0.04), border: `1px solid ${t.border}`, color: t.textMuted, fontSize: '13px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
          {tr('step4.downloadTxt')}
        </button>
        <button disabled style={{ flex: 1, padding: '14px', borderRadius: RADII.control, background: `linear-gradient(135deg, ${COLORS.accent}, ${COLORS.accent}CC)`, border: 'none', color: COLORS.surface, fontSize: '15px', fontWeight: 600, cursor: 'not-allowed', opacity: 0.5 }}>
          {tr('step4.publish')}
        </button>
      </div>
      <p style={{ marginTop: '8px', textAlign: 'center', fontSize: '10px', color: t.textFaint, fontFamily: FONT_MONO }}>
        {tr('step4.publishNote')}
      </p>
    </div>
  );
};
export default Step4Publish;
